module.exports = __webpack_public_path__ + "img/r5_921_safehome.55d76184.jpg";